/**
 * 平台类型定义
 */
export var PlatformEnum;
(function (PlatformEnum) {
    /** Web环境 */
    PlatformEnum["Web"] = "Web";
    /** Liteapp环境 */
    PlatformEnum["LiteApp"] = "LiteApp";
    /** 小程序环境 */
    PlatformEnum["Miniprogram"] = "Miniprogram";
})(PlatformEnum || (PlatformEnum = {}));
//# sourceMappingURL=types.js.map